import { Button, useOpenClose } from '@palmetto/palmetto-components';
import { useParams } from 'react-router-dom';

import { UserPermissions } from 'types';

import { useGetAccountQuery } from '../../services/accounts';
import { useIsOrgReadOnly } from '../auth/claimsUtils';
import RequirePermissions from '../auth/requirePermissions';

import { ApplyAdminStipulationModal } from './ApplyAdminStipulationModal';

const AdminStipulation = () => {
  const { id } = useParams<{ id: any }>();
  const { data: accountData, isLoading } = useGetAccountQuery(id);
  const { isOpen, handleClose, handleToggle } = useOpenClose();
  const isAllowedToExecuteAction = useIsOrgReadOnly();

  return (
    <>
      <ApplyAdminStipulationModal accountId={accountData?.id} handleClose={handleClose} isOpen={isOpen} />
      {!isLoading && (
        <RequirePermissions permissions={[UserPermissions.lightReachSupport]}>
          <Button
            tone="neutral"
            variant="secondary"
            size="sm"
            style={{ width: 'fit-content' }}
            onClick={handleToggle}
            isDisabled={accountData?.cancellation?.isCancelled}
            iconPrefix="flag"
            disabled={!isAllowedToExecuteAction}
          >
            Apply Stipulation
          </Button>
        </RequirePermissions>
      )}
    </>
  );
};

export default AdminStipulation;
